module.exports = __webpack_public_path__ + "img/sweden-colorectal-cancer-female.08351692.png";